import { Dropdown, Field, Option, Spinner } from "@fluentui/react-components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetAllChapterImageIds } from "../../hooks/useImages";

interface ImagePickerProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onImageSelect: (newValue: any) => void;
  selectedImageId?: string;
}

const ImagePicker = ({ onImageSelect, selectedImageId }: ImagePickerProps) => {
  const [, setSelectedImage] = useState<string | null>(null);

  const { data: images, isLoading: isloading } = useGetAllChapterImageIds();
  const { t } = useTranslation();
  const handleImageSelect = (imageId?: string) => {
    setSelectedImage(imageId ?? "");
    onImageSelect(imageId ?? "");
  };

  return (
    <div>
      {isloading ? (
        <Spinner />
      ) : (
        <>
          <Field
            label={
              <span style={{ fontWeight: 600 }}>{t("chooseThumbnail")}</span>
            }
          >
            <Dropdown
              id="image-picker"
              area-label="imageId"
              defaultValue={
                images?.find((f) => f.id === selectedImageId)?.title
              }
              onOptionSelect={(_, data) => {
                handleImageSelect(data.optionValue);
              }}
            >
              {images &&
                images.map((image) => (
                  <Option key={image.id} value={image.id}>
                    {image.title}
                  </Option>
                ))}
            </Dropdown>
          </Field>
        </>
      )}
    </div>
  );
};

export default ImagePicker;
